import { Col, Form, FormControl } from "react-bootstrap";
import { showErrorInput } from "../../../../utils/helperFunctions";
import { Controller, useForm } from "react-hook-form";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { BsPlus } from "react-icons/bs";
import { CustomSelect } from "../../../kits/inputs/Input.tsx";
import { addCommas } from "@persian-tools/persian-tools";
import { onlyNumber } from "../../../../utils/Tools";
import InventoryItemProduct from "./InventoryItemProduct";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { isEmpty } from "lodash";
import Select from "react-select";

import useAxios from "../../../../services/useAxios.tsx";

const InventoryProduct = ({
  formControl,
  importData = true,
  options,
  invenrotys,
  setInventorys,
}) => {
  const {execute : validateFactorApi} = useAxios("api3/validation_factor");

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [schemaInventory, setSchemaInventory] = useState();

  const [values, setValues] = useState({
    price: "",
    inventory: "",
    // factors:"",
    // factorItem:""
  });

  const formController = useForm({
    resolver: yupResolver(yup.object(schemaInventory).required()),
    values: { ...values },
    defaultValues: values,
    resetOptions: {
      keepValues: true,
      keepDirtyValues: false,
      keepErrors: true,
    },
  });


  useEffect(() => {
    let tempSchema = {
      price: yup.string().required("مبلغ نباید خالی باشد."),
      inventory: yup.string().required("تعداد نباید خالی باشد."),
    };
    let tempOptions = options.filter((it) => it.isChangedPrice);
    if (!importData) setInventorys([]);

    setSelectedOptions(tempOptions);

    let tempValue = { price: "", inventory: ""
    // ,factors:"",factorItem:"" 
  };
    tempOptions.map((it) => {
      if (it.selectedFeaturs.length != 0) {
        tempValue = { ...tempValue, [`select_${it.option_id}`]: undefined };
        tempSchema = {
          ...tempSchema,
          [`select_${it.option_id}`]: yup
            .mixed()
            .test(
              `select_${it.option_id}`,
              `${it.title} باید انتخاب شود`,
              (value) => {
                if (!value) return false;
                if (value == "") return false;
                if (value.length < 1) return false;
                return true;
              }
            ),
        };
      }
    });

    setValues(tempValue);
    setSchemaInventory(tempSchema);
    formController.reset();
  }, [options]);

  const onSubmit = (data) => {
    if (selectedOptions.length == 0 && invenrotys.length == 1) return;
// console.log("submit",data);
// validateFactorApi({factor_item_id:data?.factorItem?.value ,inventory:data?.inventory}).then(result=>{
// if (result?.data?.bigger_status != "1"){
  let tempInventory = {
    index: invenrotys.length,
    price: data.price,
    inventory: data.inventory,
    // factor_item_id:data?.factorItem.value,
    file: {},
    discount: "",
    discountTime: "",
    optionValue: options
      .filter((it) => it.isChangedPrice && it.selectedFeaturs.length != 0)
      .map((it) => data[`select_${it.option_id}`]),
      // purchase_invoice_id:data?.factorItem?.value
  };
  
  setInventorys((prev) => [...prev, tempInventory]);
  formController.reset();
  // toast.success("");
  // toast.success(`با موفقیت موجودی اضافه شد . تعداد ${result?.data?.difference} از این آیتم فاکتور باقی مانده است`);
// }else{
//   toast.error(`تعداد محصولات از فاکتور ثبت شده بیشتر است تعداد ${result?.data?.difference} از این ایتم فاکتور برای تعریف محصول در دسترس است.
//   `)
// }
// })
  };

  return (
    <div className="w-100 pd-t-12 font-14-500">
      <form id="inventory-form">
        <div className="d-flex flex-column align-items-end card border-2 border-opacity-25 shadow-sm pd-t-12 pd-x-16 mr-b-8">
          <div className="d-flex w-100 flex-wrap">
            {selectedOptions.length > 0 &&
              selectedOptions.map(
                (item) =>
                  item.selectedFeaturs.length != 0 && (
                    <Col
                      key={item.option_id}
                      xs={12}
                      sm={6}
                      md={4}
                      className="pd-x-6 mr-b-12"
                    >
                      <Controller
                        name={`select_${item.option_id}`}
                        control={formController.control}
                        render={({ field }) => (
                          <>
                            <CustomSelect
                              {...field}
                              containerClassName="shadow-none bg border-0 sm-medium rd-8 lgn-bold"
                              className="lgn-medium"
                              placeholder={`${item.title} را انتخاب نمایید`}
                              options={item.selectedFeaturs}
                              value={
                                field.value && !isEmpty(field.value)
                                  ? field.value
                                  : ""
                              }
                              labelClassName="p-0 m-0"
                              inputHeight={40}
                            />

                            {showErrorInput(
                              formController.formState.errors,
                              `select_${item.option_id}`
                            )}
                          </>
                        )}
                      />
                    </Col>
                  )
              )}
          </div>

          <div className="d-flex w-100 flex-wrap">
            <Col xs={12} sm className="pd-x-6 mr-b-12">
              <Controller
                control={formController.control}
                name={"price"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Form.Control
                    isInvalid={formController.formState.errors.price}
                    value={addCommas(value)}
                    disabled={
                      selectedOptions.length == 0 && invenrotys.length == 1
                    }
                    className="shadow-none sm-medium he-40 rd-8 pd-x-16 pd-y-6 lgn-medium"
                    placeholder="مبلغ را وارد نمایید ( تومان )"
                    onChange={({ target }) => {
                      onChange(onlyNumber(target.value, true));
                    }}
                  />
                )}
              />
              {showErrorInput(formController.formState.errors, "price")}
            </Col>

            <Col xs={12} sm className="pd-x-6 mr-b-12">
              <Controller
                control={formController.control}
                name={"inventory"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Form.Control
                    isInvalid={formController.formState.errors.inventory}
                    value={addCommas(value)}
                    disabled={
                      selectedOptions.length == 0 && invenrotys.length == 1
                    }
                    className="shadow-none sm-medium he-40 rd-8 pd-x-16 pd-y-6 lgn-medium"
                    placeholder="تعداد را وارد نمایید"
                    onChange={({ target }) => {
                      onChange(onlyNumber(target.value, true));
                    }}
                  />
                )}
              />
              {showErrorInput(formController.formState.errors, "inventory")}
            </Col>
          </div>

          <div className="mx-auto">
            <button
              type="submit"
              form="inventory-form"
              disabled={selectedOptions.length == 0 && invenrotys.length == 1}
              onClick={formController.handleSubmit(onSubmit)}
              className="d-flex justify-content-center align-items-center text-white btn bg-primary bg-opacity-75 wh-sm-36 mr-b-8 pd-sm-0"
            >
              <BsPlus className="wh-24 " />
              <span className="d-sm-none">افزودن موجودی</span>
            </button>
          </div>
        </div>
      </form>

      <div className="d-flex flex-column pd-x-12">
        {invenrotys.length > 0 ? (
          invenrotys.map((item) => (
            <InventoryItemProduct
              details={item}
              setInventorys={setInventorys}
              isOptions={selectedOptions.length > 0}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center pd-t-12 text-secondary text-opacity-75">
            <span>« هیچ موجودی ثبت نشده است »</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryProduct;
